import { ICompileService, IPromise, IQService, Injectable } from "angular";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
  IGridSettings,
} from "../../records/grids/settings/gridSettingsService";
import { StateService } from "@uirouter/angularjs";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import { vsServiceName as ContractDetailTabsServiceName } from "../shared/components/views/contract/detail/tabs";
import { FilterProvider } from "../../records/grids/columns/filters/FilterProvider";
import { ColDef } from "../../records/grids/columns/colDef";
import { RecordDataSource } from "../../records/grids";
import { moneyValueGetterFactory } from "../../records/grids/cells/valueGetters";

export const vsObjectName = "contractCost";

export function contractCostConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    "$q",
    ServerUtilityName,
    GridSettingsServiceName,
    "$state",
    (
      $q: IQService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $state: StateService
    ) =>
      new ContractGridConfiguration(
        $q,
        serverUtility,
        gridSettingsService,
        $state
      ),
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    "$compile",
    ContractDetailTabsServiceName,
    (
      columnDefinitionService: ColumnDefinitionService,
      $compile: ICompileService
    ) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        filter: new FilterProvider("Id", $compile)
          .defaultNumberFilters()
          .getGridFilterFactory(),
        hide: true,
      }),
      ...contractCostConfigurationColumns(columnDefinitionService),
    ],
  ]);
}
contractCostConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];

export function contractCostConfigurationColumns(
  columnDefinitionService: ColumnDefinitionService
): ColDef[] {
  return [
    columnDefinitionService.getStringColDef({
      field: "CostTypeName",
      header: "Cost Type Name",
    }),
    columnDefinitionService.getStringColDef({
      field: "Cost",
      header: "Cost",
    }),
    columnDefinitionService.getStringColDef({
      field: "Requisition",
      header: "Requisition#",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "PO",
      header: "PO#",
      hide: true,
    }),
    columnDefinitionService.getDateColDef({
      field: "ContractStartDate",
      header: "Contract Start",
    }),
    columnDefinitionService.getDateColDef({
      field: "ContractEndDate",
      header: "Contract End",
    }),
    columnDefinitionService.getStringColDef({
      field: "TypeOfAgreementName",
      header: "Type Of Agreement ",
    }),
    columnDefinitionService.getNumberColDef({
      field: "ContractId",
      header: "Contract Id",
      hide: true,
    }),
    
  ];
}

class ContractGridConfiguration implements GridConfiguration {
  columns?: ColDef[];
  columnDefinitionSet?: string = vsObjectName;
  onItemCommand?: Injectable<(...args: any[]) => IPromise<void>> = [
    () => {
      return this.$q.when();
    },
  ];
  gridDataSource?: RecordDataSource = new RecordDataSource(
    this.serverUtility,
    "/api/contract/contractCost"
  );
  defaultSort?: string = "Id";
  nameSingular?: string = "Contract Configuration";
  namePlural?: string = "Contract Configurations";
  showAddButton?: boolean = true;
  showAddButtonPermission?: string = "contractEdit";
  gridSelectionChanged?: Injectable<(...args: any[]) => void> = [
    () => {
      return this.$q.when();
    },
  ];
  showSelectButtons?: boolean = true;
  gridSettings?: IGridSettings;

  static $inject = ["$q", ServerUtilityName, GridSettingsServiceName, "$state"];
  constructor(
    private readonly $q: IQService,
    private readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly $state: StateService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("main.contracts.grid.2")
    );
  }

  onAddNew = () => {
    return this.$state.go("^.add").then(() => {});
  };
}
